// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__3xQir"};